import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/usr/src/nuxt-app/layouts/default.vue").then(m => m.default || m)),
  map: defineAsyncComponent(() => import("/usr/src/nuxt-app/layouts/map.vue").then(m => m.default || m))
}